import predefinedKeyStrokes from "./predefinedKeyStrokes.json";

const keyMap = new Map<string, string>(Object.entries(predefinedKeyStrokes));

export const usePredefinedKeyStroke = (key: keyof typeof predefinedKeyStrokes, handler: () => void) => {
	if (!keyMap.has(key)) {
		throw new Error(`Key ${key} is not defined`);
	}

	console.info(`Registering key stroke: ${key} - (${keyMap.get(key)})`);
	const combination = useMagicKeys({
		passive: false,
		onEventFired(e) {
			// Suppress the browser/IME default for the combos we own so they don't get eaten
			// (Ctrl+F = find, Ctrl+Space = IME/autocomplete toggle).
			if (e.ctrlKey && (e.key == "f" || e.code == "Space")) e.preventDefault();
		},
	})[keyMap.get(key) as string];
	whenever(combination, handler);
};
